import { DeleteRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import { RuleConstraint } from "../../../types";

const RemoveButton = ({
    value,
    onRemove
}: {
    value: RuleConstraint,
    onRemove: (constraint: RuleConstraint) => void
}) => {

    return (
        <Button
            color="accent"
            title="Remove"
            onClick={() => onRemove(value)}
            startIcon={<DeleteRounded />}
            sx={{ alignSelf: 'center' }}
        >
            Remove
        </Button>
    );
};

export default RemoveButton;